
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("cqdI3", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "ChoreographerRegistry", () => $4cf4f200c307e559$export$651e1f902bdd710b);
$parcel$export(module.exports, "default", () => $4cf4f200c307e559$export$2e2bcd8739ae039);

var $klywp = parcelRequire("klywp");
var $hzlvc = parcelRequire("hzlvc");

var $6LmbU = parcelRequire("6LmbU");
const $4cf4f200c307e559$var$mapEnvToAnalyticsEnv = (env)=>{
    switch(env){
        case 'test':
        case 'local':
            return (0, $6LmbU.envType).LOCAL;
        case 'dev':
            return (0, $6LmbU.envType).DEV;
        case 'staging':
        case 'stg-fedm-east':
            return (0, $6LmbU.envType).STAGING;
        case 'production':
        case 'prod-fedm-east':
            return (0, $6LmbU.envType).PROD;
        default:
            return (0, $6LmbU.envType).DEV;
    }
};
class $4cf4f200c307e559$export$651e1f902bdd710b {
    constructor(product, environment){
        this.product = product;
        this.environment = environment;
    }
    getPostOfficeChoreographerFactory() {
        if (globalThis.window.choreographerRegistry === undefined) globalThis.window.choreographerRegistry = new Map();
        const maybeChoreographerFactory = globalThis.window.choreographerRegistry.get((0, $hzlvc.ProductIds).POST_OFFICE);
        if (maybeChoreographerFactory) return maybeChoreographerFactory;
        const factory = (0, $klywp.choreographerFactory)((0, $hzlvc.ProductIds).POST_OFFICE, $4cf4f200c307e559$var$mapEnvToAnalyticsEnv(this.environment), {
            sourceProductId: this.product
        });
        globalThis.window.choreographerRegistry.set((0, $hzlvc.ProductIds).POST_OFFICE, factory);
        return factory;
    }
}
var $4cf4f200c307e559$export$2e2bcd8739ae039 = $4cf4f200c307e559$export$651e1f902bdd710b;

});


//# sourceMappingURL=choreographerRegistry.a014c22b.js.map
